/** TOKEN 存储键 */
const TOKEN_KEY = 'token';

/** 写入存储（隐私模式等场景可能抛错，忽略即可） */
function safeSet(storage: Storage, token: string): void {
  try {
    storage.setItem(TOKEN_KEY, token);
  } catch {
    // 忽略写入失败
  }
}

/** 读取存储 */
function safeGet(storage: Storage): string {
  try {
    return storage.getItem(TOKEN_KEY) || '';
  } catch {
    return '';
  }
}

/** 删除存储 */
function safeRemove(storage: Storage): void {
  try {
    storage.removeItem(TOKEN_KEY);
  } catch {
    // 忽略删除失败
  }
}

/**
 * 存储 TOKEN
 * @param token 登录接口返回的 token
 * @param remember 是否自动登录：true 存 localStorage（关闭浏览器后仍有效）；
 *                 false 存 sessionStorage（仅当前会话有效，关闭浏览器需重新登录）
 */
export function setToken(token?: string, remember = true): void {
  // 先清理，避免两处存储同时存在新旧 token
  clearToken();
  if (!token) {
    return;
  }
  safeSet(remember ? localStorage : sessionStorage, token);
}

/** 读取 TOKEN（当前会话优先，其次持久存储） */
export function getToken(): string {
  return safeGet(sessionStorage) || safeGet(localStorage);
}

/** 清除 TOKEN（两种存储都要清理） */
export function clearToken(): void {
  safeRemove(sessionStorage);
  safeRemove(localStorage);
}
